import React from 'react'
import iconPhone from '../assets/icons/mPhone.png'
import iconFacebook from '../assets/icons/facebook.svg'
import iconInstagram from '../assets/icons/instagram.svg'
import iconWhatsApp from '../assets/icons/whatsapp.svg'
import iconEmail from '../assets/icons/email.png'

const Footer = () => {
    return (
        <>

            <footer className="pt-4 footerPage" >
                <div className='cotizacionSection'>

                    <p style={{color:'#fff'}}>
                    Service Area: Bellevue, Bothell, Edmonds, Kenmore, Kirkland, Lynnwood, Medina, Mountlake Terrace, Redmond, Woodinville, Sammamish, Seattle, Everett, Arlington, Granite Falls, Lake Stevens, Marysville, Monroe, Mukilteo, Silvana, Snohomish, Stanwood
                    </p>

                </div>
                <div style={{ textAlign: "center" }}>
                    <p style={{color:'#fff'}}>P.O Box</p>
                    <iframe className="map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2669.2838938012524!2d-122.31450178490276!3d48.0082248681412!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x548fffa441100225%3A0xe648f07acf48f285!2sEverett%20Way%2C%20Washington%2098236%2C%20USA!5e0!3m2!1sen!2smx!4v1610751216211!5m2!1sen!2smx" frameborder="0" width="600" height="450" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
                </div>
                <div className='cotizacionSection mt-4 mb-4'>




                    <h4>Contact Us</h4>

                    <div className="m-2" style={{ display: 'flex', alignItems: 'center' }}>
                        <img src={iconPhone} style={{ height: "20px" }} alt="phone" />
                        &nbsp;&nbsp; <a href='tel:425346-2198' style={{ fontSize: 'auto' }}>(425) 346-2198</a>
                    </div>

                    <div className="m-2" style={{ display: 'flex', alignItems: 'center' }}>
                        <img src={iconEmail} style={{ height: "20px" }} alt="phone" />
                        &nbsp;&nbsp; <a href='mailto:Delvalleconstructionllc@gmail.com' style={{ fontSize: 'auto' }}>Delvalleconstructionllc@gmail.com</a>
                    </div>

                </div>

                <div className='footerSectionContact'>

                    <div style={{ justifyContent: 'center', display: 'flex', alignItems: 'center' }}>

                        <a href="https://www.facebook.com/Delvalleconstructionllc">

                            <img className='iconSR' src={iconFacebook} style={{ height: "30px" }} alt="phone" />
                        </a>

                        <a href="http://instagram.com">

                            <img className='iconSR' src={iconInstagram} style={{ height: "30px" }} alt="phone" />
                        </a>

                        <a href="https://api.whatsapp.com/send?phone=4253462198&text=I%20want%20more%20information%20about%20you">
                            <img className='iconSR' src={iconWhatsApp} style={{ height: "30px" }} alt="phone" />
                        </a>

                    </div>

                </div>



                <div style={{ height: '50px' }}></div>
                <div style={{ textAlign: 'center' }}>

                    <p>
                        <a href="https://desarrollalab.com" className='firma'>Created with Desarrollalab.com technology | Desarrollalab, Inc. © 2021</a>
                    </p>
                </div>
                <div style={{ height: '50px' }}></div>






            </footer>

        </>
    )
}

export default Footer;